export default "__VITE_ASSET__DyNhVNgx__"